import { RTKQueryResponseMeta } from 'src/interfaces/api.types';
import {
  AssignmentPayload,
  AssignmentResponseHeaders,
} from 'src/interfaces/assignment.types';
import AuthService from 'src/services/api/auth.service';
import { loggerService } from 'src/services/logger.service';
import { prepareAssignments } from 'src/utils/assignments.utils';

export const normalizeAssignmentsResponse = (
  fetchedAssignments: AssignmentPayload[] | undefined,
  meta?: RTKQueryResponseMeta,
) => {
  const headers = meta?.response?.headers;

  const availableDomainsHeader = headers?.get('Assignment-Available-Domains');
  const totalCountHeader = headers?.get('Assignment-Total-Count');

  const assignmentResponseHeaders: AssignmentResponseHeaders = {
    'assignment-available-domains': availableDomainsHeader ?? '',
    'assignment-total-count': totalCountHeader ?? '',
  };

  const userBk = AuthService.getUserBk();

  const preparedAssignments = fetchedAssignments?.length
    ? prepareAssignments(fetchedAssignments, userBk)
    : [];

  return {
    assignments: preparedAssignments,
    assignmentsTotalCount: assignmentResponseHeaders['assignment-total-count'],
    assignmentDomains:
      assignmentResponseHeaders['assignment-available-domains'],
  };
};

export const createAssignmentQueryErrorHandler =
  <TQueryResult, TQueryArg>(errorMessage: string) =>
  async (
    _: TQueryArg,
    {
      queryFulfilled,
    }: {
      queryFulfilled: Promise<{ data: TQueryResult; meta: object | undefined }>;
    },
  ) => {
    try {
      await queryFulfilled;
    } catch (e) {
      loggerService.logError(errorMessage);
    }
  };
